import { Component, OnInit, Inject, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Entity } from '../../objects/entity';
import { DocumentReviewsService } from '../../service/crud-entity-services/document-reviews.service';
import { WorkflowService } from '../../service/workflow.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastMessageDialog } from '../../toolbar-components/toolbar-utilities/view-utilities';
import { ViewContractModalComponent } from '../../shared/view-contract-modal/view-contract-modal.component';
import { ListOfProvisionsComponent } from '../../list-all-pages/list-of-provisions/list-of-provisions.component';
import { NewCriticalDateComponent } from '../new-critical-date/new-critical-date.component';
import { NewProvisionComponent } from '../new-provision/new-provision.component';
import { NewRiskAssessmentComponent } from '../new-risk-assessment/new-risk-assessment.component';
import { MatDialog } from '@angular/material/dialog';
import { NewAttachmentComponent } from '../new-attachment/new-attachment.component';
import { DocumentReview } from '../../objects/doc-review';
import { Contract }    from '../../objects/contract';
import { getUniqueId } from '../../shared/utilities/utilities';
import {  EntityType,
          WorkflowTypes,
          WorkflowPhases,
          WorkflowStatus,
          DatabaseAction, 
          QuestionGroup} from '../../objects/interface-library';
import { CreateTypeContract } from '../create-type-contract';
import { TemplatesListComponent } from '../../list-all-pages/attachments-sub-categories/templates-list/templates-list.component';
import { WorkflowQuestionsComponent } from '../../entity-form-components/workflow-questions/workflow-questions.component';
import { PeopleService } from '../../service/entity-services/people.service';

import { FormsModule } from '@angular/forms';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioButton } from '@angular/material/radio';

import { AgGridModule } from 'ag-grid-angular';

import * as assessmentColumns from '../../shared/entity-columns/assessment-columns';
import * as provisionColumns from '../../../app/shared/entity-columns/provisions-columns';


let _ = require('lodash');
let moment = require('moment');


@Component({
    selector: 'app-new-document-review',
    templateUrl: './new-document-review.component.html',
    styleUrls: ['./new-document-review.component.css'],
    standalone: true,
    imports: [
      FormsModule,
      MatGridListModule,
      MatDividerModule,
      MatExpansionModule,
      MatFormFieldModule,
      MatDatepickerModule,
      MatInputModule,
      MatSlideToggleModule,
      MatButtonToggleModule,
      MatSidenavModule,
      MatProgressSpinnerModule,
      MatStepperModule,
      MatRadioButton,
      AgGridModule
    ]
  })
export class NewDocumentReviewComponent extends CreateTypeContract implements OnInit {

  currentContract = null;

  waiting = false;

  multiDocViewAdditionalSourcesView: string | null = null;
  createWorkflowView = 'phases';
  attachmentSelected:any;
  latestDocument = null;

  // *** FILE UPLOADER ***
  errorUploading = false;
  fileName = null;
  fileDataUri = null;
  binaryFile = null;

  documentsForMultDocView = [];

  requestId = null;
  editExistingRequest = false;

  currentDocReview = new DocumentReview();
  currentDocReviewFullObject = null;

  party = null;
  legalEntities = [];
  sites = [];
  departments = [];
  contractType = null;
  documentTypes = [];

  // Contract File Processing //
  // pdfSource = null;
  // safePdfHtml = null;


  nameOfSavedView = null;
  showNameSavedView = false;
  loadSavedReportVisible = false;

  selectedViewMode = 'Hide Contract';

  pageTitle = null;

  workflowStatuses = [
    WorkflowStatus.Requested,
    WorkflowStatus.Open,
    WorkflowStatus.Finalized,
    WorkflowStatus.Canceled,
    WorkflowStatus.Suspended
  ]

  contractViewModesWithoutText = [
                                    'Hide',
                                    'Show'
                                  ];

  // Filtering
  filteredParties = [];
  filteredUsers = [];
  filteredLegalEntities = [];
  filteredDepartments = [];
  filteredSites = [];

  stateOfRecordList = [];
  transactionTypeList = [];
  documentTypesList = [];
  phaseList = [];
  statusList = [];
  thresholdList = [];
  workflowPriorityList = [];

  emptyArray = []; // for staging the demo.  delete this!!!

  gridApiTaskingAssignments: any;
  gridColumnApiTaskingAssignments: any;
  gridApiPartyContractCoordinator: any;
  gridColumnApiPartyContractCoordinator: any;
  gridApiPartySignatories: any;
  gridColumnApiPartySignatories: any;
  gridApiInternalCoordinators: any;
  gridApiReviewApproval: any;
  gridApiInternalSignatories: any;

  mainContractObject: any;

  notesButtonName = 'Add Comment';

  taskingColumns = [
        {
          headerName: 'Tasking',
          field: 'type',
          width: 100
        },
        {
          headerName: 'Assigned To',
          field: 'owner',
          width: 100
        },
        {
          headerName: 'Assigned By',
          field: 'assignedBy',
          width: 100
        },
        {
          headerName: 'Date Assigned',
          field: 'eventDate',
          width: 50,
          cellRenderer: this.dateFormatter
        },
        {
          headerName: 'Completion Date',
          field: 'reminderDate',
          width: 50,
          cellRenderer: this.dateFormatter
        },
        {
          headerName: 'Action Completed',
          field: 'actionCompleted',
          width: 50,
          cellRenderer: this.agGridBooleanFormatter
        },
        {
          headerName: 'Days in Process',
          field: 'eventDate',
          width: 50,
          cellRenderer: this.daysInProcessCalculator
        }
    ];



provisionsCols = [
  provisionColumns.colName,
  provisionColumns.colDescription,
  provisionColumns.colOwner,
  provisionColumns.colRiskDomain,
  provisionColumns.colRiskName
];



assessmentCols = [
  assessmentColumns.colAssessmentName,
  assessmentColumns.colAssessmentPartyName,
  assessmentColumns.colAssessmentType,
  assessmentColumns.colOwner,
  assessmentColumns.colRequiredAction,
  assessmentColumns.colStatus,
  assessmentColumns.colSourceRecord
];




  documentVersionsCols = [

        {
            headerName: 'Version',
            field: 'VersionNumber',
            width: 100
        },
        {   headerName: 'Added By',
            field: 'AddedBy',
            width: 200 
        },
        {   headerName: 'Created Date',
            field: 'CreatedDate',
            width: 200,
            cellRenderer: params => {
              let createdDateAsObject = moment.unix(params.value);
              return createdDateAsObject.format('MM/DD/YYYY');
              }            
        },
        {   headerName: 'View Document',
            field: 'directLink',
            width: 200,
            cellRenderer: params => {
              return `<a href="${params.value}" target="_blank">View</a>`;
              }
        }
  ]

  personCols = [

        {   
            headerName: 'Name',
            field: 'fullName',
            width: 100 
        },
        {   
            headerName: 'For Action',
            field: 'currentDocReview.completed',
            width: 100,
            cellRenderer: params => {
              return `<input type='checkbox' 
                      (click)="forActionCheckedHandler($event)"
                      ${params.value ? 'checked' : ''} />`;
              }
        },
        {   
            headerName: 'Process Start Date',
            field: 'processStartDate',
            width: 100 
        },
        {
            headerName: 'Completed',
            field: 'currentDocReview.completed',
            width: 100,
            cellRenderer: params => {
              return `<input type='checkbox' ${params.value ? 'checked' : ''} />`;
              }
        },
        {   
            headerName: 'Process End Date',
            field: 'processEndDate',
            width: 100 
        },
        {   
            headerName: 'Days in Process',
            field: 'daysInProcess',
            width: 50 
        },        
    ];

  userCols = [
        {headerName: 'Done',
            field: 'currentDocReview.completed',
            width: 100,
            cellRenderer: params => {
              return `<input type='checkbox' ${params.value ? 'checked' : ''} />`;
              }
        },
        {   headerName: 'Name',
            field: 'friendlyName',
            width: 200 
        }
    ];

  createdDateMomentVersion = null;
  submissionDateMomentVersion = null;

  numDaysInProcess = 0;

  renewalTypeLabels = null;

  masterSubordinateLabels = [
                              'Master Services Agreement',
                              'Subordinate Agreement',
                              'Main Grant',
                              'Supplemental Grant'
                            ];

  constructor(public router: Router,
              public dialog: MatDialog,
              private _snackBar: MatSnackBar,
              public docReviewsService: DocumentReviewsService) {

    super();

  }

  async ngOnInit() {

    let datetimestamp = (new Date).getTime().toString();


    // if (this.globalDataService.currentDocumentReview) {
    //   // this.currentDocReview = this.globalDataService.currentDocumentReview;
    //   this.currentDocReview = _.cloneDeep(this.globalDataService.currentDocumentReview);

    //   if (!this.currentDocReview.EntityId) {
    //     this.currentDocReview.EntityId = getUniqueId();
    //   }

    //   if (!this.currentDocReview.Id) {
    //     this.currentDocReview.Id = this.currentDocReview.EntityId;
    //     // this.currentDocReview.Id = this.currentDocReview.EntityId + '-' + datetimestamp;
    //   }

    //   if (!this.currentDocReview.Type) {
    //     this.currentDocReview.Type = WorkflowTypes.Request;
    //   }

    //   if (!this.currentDocReview.SubType) {
    //     this.currentDocReview.SubType = EntityType.Contract;
    //   }

    //   this.globalDataService.currentDocumentReview = null;
    // } else {
    // // Follow Assumes a NEW Request
    //   // setting requestor doesn't work because it is an email instead of user object
    //   this.currentDocReview.entityUnderReviewObject = new Contract();
    //   this.currentDocReview.entityUnderReviewType = EntityType.Contract;
    //   this.currentDocReview.requestor = this.globalDataService.email;
    //   this.currentDocReview.phase = WorkflowPhases.PhaseI;
    //   this.currentDocReview.Status = WorkflowStatus.Requested;
    //   this.currentDocReview.EntityId = getUniqueId();
    //   this.currentDocReview.Type = WorkflowTypes.Request;
    //   this.currentDocReview.SubType = EntityType.Contract;

    //   this.currentDocReview.Id = this.currentDocReview.EntityId + '-' + datetimestamp;
    // }

    // var now = moment();
    // this.currentDocReview.CreatedDate = now.unix();

    // this.getStaticFieldValues();
    // this.populateNecessaryLists();


    // // this.workflowService.getRequestByNum('1619134705834');  <-- this is how you get a specific request

    // // *** Below Here Needs Updating ***

    // // console.log('created date: ', this.currentDocReview.CreatedDate);
    // let createdDateAsMomentObject = moment.unix(this.currentDocReview.CreatedDate);
    // let submissionDateAsMomentObject = moment.unix(this.currentDocReview.SubmissionDate);
    // this.createdDateMomentVersion = createdDateAsMomentObject.format('ll');
    // this.submissionDateMomentVersion = submissionDateAsMomentObject.format('ll');
    // // console.log('submission date: ', this.currentDocReview.SubmissionDate);
    // // console.log('days in progress unix time: ', submissionDateAsMomentObject.format('ll'));


    // if (this.currentDocReview.mainFileName) {
    //   this.processContractFileAttachment(this.currentDocReview.mainFileName);
    // } else {
    //   console.warn('new-document-review | noOnInit | doc review has no document');
    // }

    // this.calculateNumDaysInProcess();

    // this.currentDocReview.documentList = await this.workflowService.getDocumentList(this.currentDocReview.EntityId);

    // this.getSheetsData();

    // this.currentContract = await this.contractManagerService.getContractById(this.currentDocReview.EntityId);

    // this.setLatestDocumentVersion();
  }


  onTaskingClicked(taskingData) {


    const dialogRef = this.dialog.open(NewCriticalDateComponent, {
      width: '1000px',
      data: {
              criticalDateData: taskingData.data,
              message: 'Make updates or edits to this tasking: ' + this.currentDocReview.name,
              title: 'Edit Tasking',
              tasking: true
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {

        // console.log('*** result: ', result);
        // console.log('*** tasking assignments updated: ', this.currentDocReview.taskingAssignments);

        //BUGBUG:  This is the wrong way.  Should only save the numbers.
        //          leaving for the demo.

        // Remove edited item from the array
        let taskingWithoutEditedItem = this.currentDocReview.taskingAssignments.filter( tasking => tasking.criticalDateNum !== result.criticalDateNum);

        // Add the result to the array
        let taskingWithEditedItem = taskingWithoutEditedItem.concat(result);

        this.currentDocReview.taskingAssignments = taskingWithEditedItem;

        // console.log('*** updated tasking array: ', this.currentDocReview.taskingAssignments);

        await this.saveDocumentReview();

        var params = {
          force: true,
          suppressFlash: false,
        };

        this.gridApiTaskingAssignments.refreshCells(params);

      }

    });    

  }



  addNewTasking(): void {

    const dialogRef = this.dialog.open(NewCriticalDateComponent, {
      width: '1000px',
      data: {
              entityNumber: this.currentDocReview.Id,
              entityId: this.currentDocReview.Id,
              entityType: EntityType.Workflow,
              // entityName: this.currentContract.nameOfContract,
              // entityLink: environment.linkToDeployment + 'contract/' + this.currentContract.contractNum,
              message: 'Workflow Name: ' + this.currentDocReview.name,
              title: 'Add Tasking',
              tasking: true
            }
      });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        if (!this.currentDocReview.taskingAssignments) {
          this.currentDocReview.taskingAssignments = [];
        }

        // console.log('*** result: ', result);

        // BUGBUG:  this is wrong.  in the future just save the number then load it 
        //          from dynamodb.  leaving for demo.
        this.currentDocReview.taskingAssignments = this.currentDocReview.taskingAssignments.concat(result);

        // console.log('*** tasking assignments updated: ', this.currentDocReview.taskingAssignments);

        this.saveDocumentReview();

        var params = {
          force: true,
          suppressFlash: false,
        };

        this.gridApiTaskingAssignments.refreshCells(params);

      }

    });
  }



  openWorkflowQuestions() {

    const dialogRef = this.dialog.open(WorkflowQuestionsComponent, {
      width: '1000px',
      height: '800px',
      data: {
              questionGroup: QuestionGroup.PhysicianEmploymentAgreement,
              previousAnswers: this.currentDocReview.questions
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {
        // console.log('*** result of questions prompt: ', result);
        this.currentDocReview.questions = result;

        for (let [key, value] of Object.entries(this.currentDocReview.questions)) {
            // console.log(key, value);

            // BUGBUG:  Add Legal Entity

            if (key.indexOf('Clinical Specialty') >= 0) {
              this.currentDocReview.physicianEmploymentAgreement.internalOrFamily = value;
            }

            if (key.indexOf('Commencement Date') >= 0) {
              this.currentDocReview.physicianEmploymentAgreement.commencementDate = value;
            }

            if (key.indexOf('Base Salary') >= 0) {
              this.currentDocReview.physicianEmploymentAgreement.baseSalary = value;
            }

            if (key.indexOf('Signing Bonus') >= 0) {
              this.currentDocReview.physicianEmploymentAgreement.signingBonus = value;
            }

            if (key.indexOf('Forgivable Loan') >= 0) {
              this.currentDocReview.physicianEmploymentAgreement.forgivableLoan = value;
            }

            await this.saveDocumentReview();

        }
        

      } else {
      }
    });

  }


  async generateDocumentFromTemplate() {

    // console.log('*** generateDocumentFromTemplate: ', this.currentDocReview);

    this.waiting = true;

    let legalEntitiesFriendlyName = '*** TBD ***';

    if (this.currentDocReview.legalEntities) {
      legalEntitiesFriendlyName = this.currentDocReview.legalEntities[0].legalEntityName;
    }

    let physicianEmploymentAgreementUpdateDocObject = {
      '{{firstname}}': 'Alan Watts',
      '{{partyDrName}}': this.currentDocReview.party.name,
      '{{legalEntityName}}': legalEntitiesFriendlyName,
      '{{internalOrFamily}}': this.currentDocReview.physicianEmploymentAgreement.internalOrFamily,
      '{{commencementDate}}': this.currentDocReview.physicianEmploymentAgreement.commencementDate,
      '{{term}}': this.currentDocReview.term,
      '{{partyDrAddress}}': this.currentDocReview.party.address,
      '{{partyDrCity}}': this.currentDocReview.party.city,
      '{{partyDrState}}': this.currentDocReview.party.state,
      '{{partyDrZip}}': this.currentDocReview.party.zip,
      '{{baseSalary}}': this.currentDocReview.physicianEmploymentAgreement.baseSalary,
      '{{signingBonus}}': this.currentDocReview.physicianEmploymentAgreement.signingBonus,
      '{{sitesNames}}': '*** TBD ***',
      '{{forgivableLoan}}': this.currentDocReview.physicianEmploymentAgreement.forgivableLoan
    };

    // let physicianEmploymentAgreementUpdateDocObject = {
    //   '{{firstname}}': 'Alan Watts',
    //   '{{partyDrName}}': this.currentDocReview.party.name,
    //   '{{legalEntityName}}': legalEntitiesFriendlyName,
    //   '{{internalOrFamily}}': 'Internal Family Medicine',
    //   '{{commencementDate}}': '1/1/1111',
    //   '{{term}}': '33',
    //   '{{partyDrAddress}}': this.currentDocReview.party.address,
    //   '{{partyDrCity}}': this.currentDocReview.party.city,
    //   '{{partyDrState}}': this.currentDocReview.party.state,
    //   '{{partyDrZip}}': this.currentDocReview.party.zip,
    //   '{{baseSalary}}': '223344',
    //   '{{signingBonus}}': '987654',
    //   '{{sitesNames}}': 'Algona Pacific',
    //   '{{forgivableLoan}}': '55555'
    // };

    // let autoGeneratedDocumentResponse = await this.workflowService.generateDocumentFromTemplate(this.currentDocReview.Id, physicianEmploymentAgreementUpdateDocObject);

    // console.log('response from auto generate document');
    // console.log(autoGeneratedDocumentResponse);
    // console.log(autoGeneratedDocumentResponse.linkToFile);

    // await this.writeDocumentToDatabase(autoGeneratedDocumentResponse.fileName);

    // // UPDATE DOCUMENT LIST
    // this.currentDocReview.documentList = await this.workflowService.getDocumentList(this.currentDocReview.EntityId);

    // // this.processExistingFile(autoGeneratedDocumentResponse.linkToFile);

    // this.waiting = false;
  }




  async setLatestDocumentVersion() {

    // console.log('*** doc list: ', this.currentDocReview.documentList);
    
    // this.currentDocReview.documentList.forEach( draftDoc => {
    //     if (this.latestDocument === null || this.latestDocument.VersionNumber < draftDoc.VersionNumber) {
    //       this.latestDocument = draftDoc;
    //     }
    // });

    // console.log('*** latestDoc: ', this.latestDocument);

    // if (this.latestDocument && this.latestDocument.directLink) {
    //   this.addFileToView(this.latestDocument.directLink);
    // }
    // let responseFromFileProcess = await this.attachmentUtil.processMainContractFileAttachment(this.latestDocument.directLink);

    // console.log('response from file process: ', responseFromFileProcess);

    // this.latestDocument = responseFromFileProcess;
  }


  multiDocAdditionalSourceAssociatedContracts() {
    this.multiDocViewAdditionalSourcesView = 'associated-contracts';
  }


  multiDocAdditionalSourceAttachments() {
    this.multiDocViewAdditionalSourcesView = 'attachments';
  } 



  receiveAssociatedContractClicked(event) {

    this.addContractObjectToMultiDocView(event);

    // if (event.contractFileName) {
    //   this.addContractObjectToMultiDocView(event);
    //   // this.addFileToView(event.contractFileName);
    // }

  }



  receiveMessage($event) {
    this.attachmentSelected = $event
    // console.log('attachment selected: ', this.attachmentSelected);
    this.addFileToView(this.attachmentSelected.s3filename);
  }


  async onDocumentCellClicked(event) {

    if (this.createWorkflowView === 'multipleDocumentView') {
      this.addFileToView(event.data.directLink);
    }
  }


  async addContractObjectToMultiDocView(contractObject) {

    // if (contractObject && contractObject.contractFileName) {
    //   let fileNameArray = contractObject.contractFileName.split('/');
    //   let fileName = fileNameArray[fileNameArray.length -1];
    //   let documentToAdd = await this.attachmentUtil.processMainContractFileAttachment(fileName);
    //   documentToAdd.name = contractObject.nameOfContract;
    //   documentToAdd.id = contractObject.contractId;
    //   this.documentsForMultDocView.push(documentToAdd);  
    // }

    // console.log('*** document array: ', this.documentsForMultDocView);

  }


  async addFileToView(filename) {

    // let fileNameArray = filename.split('/');
    // let fileName = fileNameArray[fileNameArray.length -1];
    // let documentToAdd = await this.attachmentUtil.processMainContractFileAttachment(fileName);
    // this.documentsForMultDocView.push(documentToAdd);

    // console.log('document array: ', this.documentsForMultDocView);

  }


  toggleMultipleDocumentView(event) {
    // BUGBUG:  This function isn't used for anything.
  }


  getSheetsData() {

    // this.googleSheetsService
    //     .getRenewalTypeLabels()
    //     .then(sheetsResponse => {

    //       let listOfRenewalTypes = sheetsResponse.values[0];

    //       let renewalTypeArray = [];

    //       listOfRenewalTypes.forEach(renewaltype => {
    //           let statusObject = {
    //                                 'value': renewaltype,
    //                                 'label': renewaltype
    //                               };

    //           renewalTypeArray.push(statusObject);
    //         });

    //       this.renewalTypeLabels = renewalTypeArray;

    //     });

  }


  calculateNumDaysInProcess() {

    let today = moment();
    let submissionDate = moment.unix(this.currentDocReview.SubmissionDate);

    // this.numDaysInProcess = submissionDate.diff(today, 'days');
    this.numDaysInProcess = today.diff(submissionDate, 'days');

    if (this.numDaysInProcess < 1 || !submissionDate.isValid()) {
      this.numDaysInProcess = 0;
    }

  }


  async createRecord() {

    // this.currentDocReview.Status = WorkflowStatus.Finalized;

    // this.saveDocumentReview();

    // this.globalDataService.currentDocumentReview = null;

    // // BUGBUG:  only works for NEW contract
    // // If a NEW contract then just make a new contract
    // // If you are replacing a contract then we have work to do.

    // let newContractObject = new Contract();

    // // newContractObject = this.populateContractWithWorkflowData(newContractObject);

    // console.log('current doc review: ', this.currentDocReview);

    // if (this.currentDocReview.mainFileName) {
    //   await this.processContractFileAttachment(this.currentDocReview.mainFileName);
    // }

    // newContractObject.attachments = this.currentDocReview.attachments;
    // newContractObject.contractType = this.currentDocReview.contractType;
    // newContractObject.contractId = this.currentDocReview.EntityId;
    // newContractObject.departments = this.currentDocReview.departments;
    // newContractObject.description = this.currentDocReview.description;
    // newContractObject.baas = this.currentDocReview.baas;
    // newContractObject.cois = this.currentDocReview.cois;
    // newContractObject.effectiveDate = this.currentDocReview.effectiveDate;
    // newContractObject.embeddedBaa = this.currentDocReview.embeddedBaa;
    // newContractObject.contractFileDirectLink = this.mainContractObject.directLink;
    // newContractObject.contractFileName = this.currentDocReview.mainFileName;
    // newContractObject.criticalDates = this.currentDocReview.importantDates;
    // newContractObject.legalEntities = this.currentDocReview.legalEntities;
    // newContractObject.nameOfContract = this.currentDocReview.name;
    // newContractObject.directVendor = this.currentDocReview.party;
    // newContractObject.sites = this.currentDocReview.sites;

    // console.log('New Contract from Workflow: ', newContractObject);

    // this.globalDataService.currentContract = _.cloneDeep(newContractObject);

    // this.globalDataService.editContract = true;

    // this.router.navigateByUrl('/securehome/new-contract');
  }


  async populateContractWithWorkflowData(contractObject: Contract) : Promise<Contract> {

    // console.log('current doc review: ', this.currentDocReview);

    if (this.currentDocReview.mainFileName) {
      await this.processContractFileAttachment(this.currentDocReview.mainFileName);
    }

    contractObject.attachments = this.currentDocReview.attachments;
    contractObject.contractType = this.currentDocReview.contractType;
    contractObject.contractId = this.currentDocReview.EntityId;
    contractObject.departments = this.currentDocReview.departments;
    contractObject.description = this.currentDocReview.description;
    contractObject.baas = this.currentDocReview.baas;
    contractObject.cois = this.currentDocReview.cois;
    contractObject.effectiveDate = this.currentDocReview.effectiveDate;
    contractObject.embeddedBaa = this.currentDocReview.embeddedBaa;
    contractObject.contractFileDirectLink = this.mainContractObject.directLink;
    contractObject.contractFileName = this.currentDocReview.mainFileName;
    contractObject.criticalDates = this.currentDocReview.importantDates;
    contractObject.legalEntities = this.currentDocReview.legalEntities;
    contractObject.nameOfContract = this.currentDocReview.name;
    contractObject.directVendor = this.currentDocReview.party;
    contractObject.sites = this.currentDocReview.sites;
    // contractObject.isOfficeDocument = this.isOfficeDocument;

    return contractObject;
  }




  openApprovedProvisionsList(): void {

    const dialogRef = this.dialog.open(ListOfProvisionsComponent, {
      width: '1000px',
      data: {
        approvedProvisions: true,
        listOfProvisionsTitle: 'Approved Provisions'
      }
    });

    dialogRef.afterClosed().subscribe(async result => {

      // console.log('From dialog =-> ', result);

    });
  }








  newTaskingAssignment() {

    const dialogRef = this.dialog.open(NewCriticalDateComponent, {
      width: '1000px',
      data: {
              entityNumber: this.currentDocReview.EntityId,
              entityId: this.currentDocReview.EntityId,
              entityType: EntityType.Contract,
              entityName: this.currentDocReview.name,
              message: 'Tasking Assignment ',
              title: 'Add Tasking Assignment'
            }
      });

    dialogRef.afterClosed().subscribe(result => {

      // if (result) {
      //   this.currentContract.criticalDates.push(result);
      // }

    });

  }


  
  async writeDocumentToDatabase(fileName) {

    // this.processContractFileAttachment(fileName);
    // this.currentDocReview.mainFileName = fileName;

    // // var now = moment();

    // this.currentDocReview.documentList = await this.workflowService.getDocumentList(this.currentDocReview.EntityId);
    // // console.log('num documents: ', numberOfDocuments);
    // let numberOfDocuments = this.currentDocReview.documentList.length + 1;

    // let workflowDocument = {
    //   AddedBy: this.globalDataService.email,
    //   EntityId: this.currentDocReview.EntityId,
    //   VersionNumber: numberOfDocuments,
    //   Type: WorkflowTypes.Document,
    //   SubType: EntityType.Contract,
    //   CreatedDate: this.currentDocReview.CreatedDate, // Use the
    //   directLink: this.mainContractObject.directLink,
    //   isOfficeDocument: this.mainContractObject.isOfficeDocument,
    //   officeFileLink: this.mainContractObject.officeFileLink,
    //   safeOfficeFileLink: this.mainContractObject.safeOfficeFileLink,
    //   safePdfHtml: this.mainContractObject.safePdfHtml
    // }

    // await this.workflowService.createNewWorkflowRequest(workflowDocument);
  }



  addContractFile(): void {

    // const dialogRef = this.dialog.open(NewAttachmentComponent, {
    //   width: '800px',
    //   data: {
    //           mainContractFile: true,
    //           message: 'Add a document for this Workflow Request.',
    //           title: 'Workflow Request Document'
    //         }
    // });

    // dialogRef.afterClosed().subscribe(async result => {

    //   if (result) {

    //     await this.writeDocumentToDatabase(result.s3filename);
    //     // UPDATE DOCUMENT LIST
    //     this.currentDocReview.documentList = await this.workflowService.getDocumentList(this.currentDocReview.EntityId);

    //     // console.log('Document List: ', this.currentDocReview.documentList);

    //   }

    // });
  }


  addAttachmentToRequest(attachmentName): void {

    const dialogRef = this.dialog.open(NewAttachmentComponent, {
      width: '800px',
      data: {
              mainContractFile: true,
              message: 'Add attachment to Workflow Request.',
              title: 'Workflow Request Attachment'
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {

        // console.log('result: ', result);

        this.processAttachmentAddedToRequest(attachmentName, result.s3filename);

        // this.currentDocReview.contractFileDirectLink = environment.s3Location + result.s3filename;
        this.currentDocReview.mainFileName = result.s3filename;
      }

    });
  }  


  async processAttachmentAddedToRequest(attachmentName, fileName) {

    // let attachmentData = await this.attachmentUtil.processMainContractFileAttachment(fileName);

    // console.log('attachment Data: ', attachmentData);

    // let attachmentObject = {
    //   isOfficeDocument: attachmentData['isOfficeDocument'],
    //   directLink: attachmentData['directLink'],
    //   trustedOfficeSource: null,
    //   showPdfSafeHtml: null,
    //   fileName: fileName,
    //   attachmentName: attachmentName
    // }

    // if (attachmentData['isOfficeDocument']) {
    //   attachmentObject.trustedOfficeSource = attachmentData['safeOfficeFileLink'];
    // } else {
    //   attachmentObject.showPdfSafeHtml = attachmentData['safePdfHtml'];
    // }

    // console.log('attachmentObject: ', attachmentObject);

    // this.currentDocReview.physician[attachmentName] = attachmentObject;

    // console.log('updated currentDocReview: ', this.currentDocReview.physician);

  }


  viewAttachmentDialog(attachmentName): void {

    const dialogRef = this.dialog.open(ViewContractModalComponent, {
      width: '800px',
      data: {
              linkToPdf: this.currentDocReview.physician[attachmentName]
            }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The viewContractDialog dialog was closed');
    });
  }



  replacedDocReviewVersionToast(): void {


    this._snackBar.openFromComponent(ToastMessageDialog, {
      duration: 5000,
    });

  }




  async processExistingFile(mainFileDirectLink) {

    // let mainContractObject = await this.attachmentUtil.processMainContractFileAttachment(mainFileDirectLink);

    // this.isOfficeDocument = mainContractObject['isOfficeDocument'];

    // if (this.isOfficeDocument) {
    //   this.trustedOfficeSource = mainContractObject['safeOfficeFileLink'];
    // } else {
    //   this.showPdfSafeHtml = mainContractObject['showPdfSafeHtml'];
    //   // this.safePdfHtml = mainContractObject['safePdfHtml'];
    // }

    // console.log('process existing file: ', mainContractObject);
    
  }


  async processFileAttachment(fileName) {

    // let documentToReturn = {
    //   isOfficeDocument: false,
    //   fileName: fileName,
    //   trustedOfficeSource: null,
    //   showPdfSafeHtml: null
    // }

    // let currentMainFile = await this.attachmentUtil.processMainContractFileAttachment(fileName);

    // documentToReturn.isOfficeDocument = currentMainFile.isOfficeDocument;

    // if (documentToReturn.isOfficeDocument) {
    //   documentToReturn.trustedOfficeSource = this.mainContractObject['safeOfficeFileLink'];
    // } else {
    //   documentToReturn.showPdfSafeHtml = this.mainContractObject['safePdfHtml'];
    // }

    // return documentToReturn;
  }




  async processContractFileAttachment(fileName) {

    // this.mainContractObject = await this.attachmentUtil.processMainContractFileAttachment(fileName);

    // this.isOfficeDocument = this.mainContractObject['isOfficeDocument'];

    // if (this.isOfficeDocument) {
    //   this.trustedOfficeSource = this.mainContractObject['safeOfficeFileLink'];
    // } else {
    //   this.showPdfSafeHtml = this.mainContractObject['safePdfHtml'];
    // }

    // this.selectedViewMode = 'Hide';

  }


  async addDataToEntityObject() {

    this.currentDocReview.entityUnderReviewObject.directVendor = this.party;
    this.currentDocReview.entityUnderReviewObject.legalEntities = this.legalEntities;
  }


  saveDocReviewAsPending() {

    this.currentDocReview.Status = WorkflowStatus.Pending;

    // console.log('*** saveDocReviewAsPending: ', this.currentDocReview);

    this.saveDocumentReview();

    this.router.navigateByUrl('/securehome/document-review-list');

  }


  async openAssociatedContractsList() {

    // this.currentContract = await this.contractManagerService.getContractById(this.currentDocReview.EntityId);
  }





  openApprovedTemplateList(): void {

    // const dialogRef = this.dialog.open(TemplatesListComponent, {
    //   width: '500px',
    //   data: {
    //     attachmentType: 'Approved Template',
    //     listTitle: 'Approved Template(s)'
    //   }
    // });

    // dialogRef.afterClosed().subscribe(async result => {

    //   if (result) {
    //     await this.writeDocumentToDatabase(result.attachmentData.s3filename);
    //     this.currentDocReview.documentList = await this.workflowService.getDocumentList(this.currentDocReview.EntityId);
    //     this.currentDocReview.approvedTemplate = true;
    //   }

    // });
  }



  previewApprovedTemplateMultiDocView(): void {

    this.multiDocViewAdditionalSourcesView = null;

    const dialogRef = this.dialog.open(TemplatesListComponent, {
      width: '500px',
      data: {
        attachmentType: 'Approved Template',
        listTitle: 'Approved Template(s)'
      }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {
        await this.addFileToView(result.attachmentData.s3filename);
      }

    });
  }



  async saveDocumentReview() {
    // console.log('*** current Document Review to save: ', this.currentDocReview);

    // if (!this.currentDocReview.SubmissionDate) {
    //   let now = moment();
    //   this.currentDocReview.SubmissionDate = now.unix();  
    // }

    // if (this.currentDocReview.entityUnderReviewId) {

    //   // let contractToUpdate = new Contract();
    //   let contractToUpdate = null;
    //   contractToUpdate = await this.contractManagerService.getContractByNumber(this.currentDocReview.entityUnderReviewId);

    //   if (contractToUpdate.workflowRequests) {
    //     contractToUpdate.workflowRequests.push(this.currentDocReview.Id);
    //   } else {
    //     contractToUpdate.workflowRequests = [this.currentDocReview.Id];
    //   }

    //   let contractState = contractToUpdate.state ? contractToUpdate.state : null;

    //   if (contractState) {
    //     console.log('*** List of workflow requests on contract: ', contractToUpdate.workflowRequests);

    //     await this.contractManagerService.writeContract(contractToUpdate,
    //                                                     contractState,
    //                                                     this.globalDataService.email,
    //                                                     DatabaseAction.WorkflowRequest);
  
    //   } else {
    //     console.error('new-document-review | saveDocumentReview | tried to update a contract/entity that is not active: contractToUpdate');
    //     console.log('contract state: ', contractState);
    //   }

    //   let workflowRequestResponse = await this.workflowService.createNewWorkflowRequest(this.currentDocReview);
    //   console.log('added new workflow request FROM EXISTING CONTRACT: ', workflowRequestResponse);      

    // } else {
    //   let workflowRequestResponse = await this.workflowService.createNewWorkflowRequest(this.currentDocReview);
    //   console.log('*** added new workflow request: ', workflowRequestResponse);
    // }


  }


  submitDocumentReview() {

    this.saveDocumentReview();

    this.router.navigateByUrl('/securehome/document-review-list');
  }


  cancelDocumentReview() {
    this.router.navigateByUrl('/securehome/document-review-list');
  }




  openNewProvisionDialog(): void {

    const dialogRef = this.dialog.open(NewProvisionComponent, {
      width: '1500px',
      data: {
              contractNum: this.currentDocReview.Id,
              contractName: this.currentDocReview.name
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {

        // console.log('Workflow - Provision Result: ', result);
      }

    });
  }


  // Create a new ASSESSMENT
  openNewRiskAssessmentDialog(): void {

    const dialogRef = this.dialog.open(NewRiskAssessmentComponent, {
      width: '1400px',
      height: '700px',
      data: {
        contractNum: this.currentDocReview.Id,
        contractName: this.currentDocReview.name,
        partyFriendlyName: this.currentDocReview.party
      }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {

            // console.log('new assessment result: ', result);

          }
    });
  }


  openOigExclusions() {
    window.open('https://exclusions.oig.hhs.gov/', "_blank");
  }

  openDocuSign() {
    window.open('https://app.docusign.com/home', "_blank");
  }

  openAdobeSign() {
    window.open('https://secure.echosign.com/public/login', "_blank");
  }

  saveAndSendDocReview() {
  }

  saveDocReviewListAsCSV() {
  }

  saveDocReviewListAsExcel() {
  }




  async onTaskingAssignmentsGridReady(params) {
    this.gridApiTaskingAssignments = params.api;
    this.gridColumnApiTaskingAssignments = params.columnApi;
    await this.delay(2000);
    this.gridApiTaskingAssignments.sizeColumnsToFit();
  }


  async onPartyContractCoordinatorGridReady(params) {
    this.gridApiPartyContractCoordinator = params.api;
    this.gridColumnApiPartyContractCoordinator = params.columnApi;
    await this.delay(1000);
    this.gridApiPartyContractCoordinator.sizeColumnsToFit();
  }

  async onPartySignatoriesGridReady(params) {
    this.gridApiPartySignatories = params.api;
    this.gridColumnApiPartySignatories = params.columnApi;
    await this.delay(1000);
    this.gridApiPartySignatories.sizeColumnsToFit();
  }

  onInternalCoordinatorsGridReady(params) {
    this.gridApiInternalCoordinators = params.api;
    this.gridApiInternalCoordinators = params.columnApi;
  }

  onReviewApprovalGridReady(params) {
    this.gridApiReviewApproval = params.api;
    this.gridApiReviewApproval = params.columnApi;
  }

  onInternalSignatoriesGridReady(params) {
    this.gridApiInternalSignatories = params.api;
    this.gridApiInternalSignatories = params.columnApi;
  }


  addFileFromUser(): void {

    this.multiDocViewAdditionalSourcesView = null;

    const dialogRef = this.dialog.open(NewAttachmentComponent, {
      width: '500px',
      data: {
              // personNum: this.currentContact.contactNum,
              // person: this.currentContact
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      await this.addFileToView(result.s3filename);

    });
  }  

}
